import { Bitcoin, Eth, Tron, Usdt, Vatan } from '@repo/icons';
import BTC from '@/assets/landing-banners/crypto-cards/BTC-card.png';
import ETH from '@/assets/landing-banners/crypto-cards/ETH-card.png';
import TRON from '@/assets/landing-banners/crypto-cards/TRON-card.png';
import USDT from '@/assets/landing-banners/crypto-cards/USDT-card.png';
import VATAN from '@/assets/landing-banners/crypto-cards/VATAN-card.png';

export const CRYPTO_CARDS = [
  {
    id: 'USDT',
    src: USDT,
    Icon: Usdt,
    alt: 'USDT Deposit Card',
  },
  {
    id: 'TRON',
    src: TRON,
    Icon: Tron,
    alt: 'TRON Deposit Card',
  },
  {
    id: 'BTC',
    src: BTC,
    Icon: Bitcoin,
    alt: 'BTC Deposit Card',
  },
  {
    id: 'ETH',
    src: ETH,
    Icon: Eth,
    alt: 'ETH Deposit Card',
  },
  {
    id: 'VATAN',
    src: VATAN,
    Icon: Vatan,
    alt: 'VATAN Deposit Card',
  },
];
